"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainDefinition = void 0;
class ChainDefinition {
    constructor(id, chain, direction) {
        this.id = id;
        this.chain = chain;
        this.direction = direction;
    }
}
exports.ChainDefinition = ChainDefinition;
//# sourceMappingURL=ChainDefinition.js.map